<template>
  <svg
    width="8"
    height="15"
    viewBox="0 0 8 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.37227 14.5V8.12433H7.59351L7.92368 5.62805H5.37227V4.03802C5.37227 3.31769 5.57953 2.8245 6.64717 2.8245H8V0.598925C7.34177 0.530618 6.68015 0.497637 6.01816 0.500132C4.05479 0.500132 2.70678 1.66076 2.70678 3.79143V5.62338H0.5V8.11966H2.7116V14.5H5.37227Z"
      fill=""
    />
  </svg>
</template>
